import createReactComponent from '../createReactComponent';
var ArrowBigLeft = createReactComponent('ArrowBigLeft', [['path', {
  d: 'm3 12 7-7v4h11v6H10v4z',
  key: '1e8ocp'
}]]);
export default ArrowBigLeft;